import { CustomValidationError } from 'components/common/style'
import {
  RichTextEditorWrapper,
  StyledQuillEditor,
} from 'components/business/RichTextEditor/style'

type TRichTextEditorProps = {
  value: string | undefined
  errorMessage?: string
  placeholder?: string
  handleChange: (field: string, value: any) => void
  handleBlur?: (e: any) => void
  name: string
  isDisabled?: boolean
  fieldTouched?: boolean
  maxHeight?: string
  minHeight?: string
  setTouched?: (touched: any, shouldValidate?: boolean) => void
  setFieldTouched?: (field: string) => void
  borderRadius?: string
  borderColor?: string
}

export const RichTextEditor = ({
  value = '',
  fieldTouched,
  placeholder,
  errorMessage = '',
  isDisabled = false,
  minHeight = '100px',
  maxHeight = '200px',
  handleBlur,
  handleChange,
  name,
  setTouched,
  setFieldTouched,
  borderRadius,
  borderColor,
}: TRichTextEditorProps) => {
  return (
    <RichTextEditorWrapper
      maxHeight={maxHeight}
      minHeight={minHeight}
      {...(borderRadius && { borderRadius })}
    >
      <StyledQuillEditor
        value={value}
        {...(borderRadius && { borderRadius })}
        {...(borderColor && { borderColor })}
        onChange={(content, quill) => {
          // If the editor is empty, the content string still has some empty HTML (<p><br/></p>).
          // This introduces issues when we try to validate the field.
          // getText() method returns the pure string only (which can consist of empty spaces only too), without any markup.
          if (quill.getText().trim().length) {
            handleChange(name, content)
          } else {
            handleChange(name, '')
          }
        }}
        placeholder={placeholder}
        {...(errorMessage &&
          fieldTouched && { className: 'rich_text_editor__hasError' })}
        {...(isDisabled && { className: 'rich_text_editor__isDisabled' })}
        onBlur={quill => {
          handleBlur && handleBlur(quill.root.innerHTML)
          setTouched && setTouched({ [name]: true }, true)
          setFieldTouched && setFieldTouched(name)
        }}
        readOnly={isDisabled}
      />
      {errorMessage && fieldTouched ? (
        <CustomValidationError>{errorMessage}</CustomValidationError>
      ) : null}
    </RichTextEditorWrapper>
  )
}
